import React from 'react';
import { Space , Statistic } from 'antd';
import { StyledWrapper } from './styled';

function Stat({ items, onClick, selected }) {

  const handleClick = (key) => () => onClick(key);

  return (
    <Space size="middle">
      {items.map( ({ key, title, value }) => (
        <StyledWrapper onClick={handleClick(key)} key={key} selected={key === selected}>
          <Statistic className='clickable-statistic'
            title={title}
            value={value}
          />
        </StyledWrapper>
      ))}
    </Space>
  );
}

export default Stat;
